import { FaRegCalendarAlt, FaRegClock } from "react-icons/fa";
import { DateTime } from "luxon";
import { monthKey, occurrenceStart } from "../components/calendarFunctions";

/**
 *
 * @param {*} string a viewcy api description string with html
 * @returns the string without the html tags
 */
export function cleanHTML(string) {
  return string.replace(/<[^>]+>/g, " ").replace(/&[a-zA-Z0-9]+;/g, " ");
}

/**
 * Convert an ISO date string to a Luxon DateTime in the venue's timezone
 */
function toVenueTime(isoString, timezone) {
  return DateTime.fromISO(isoString, { zone: "utc" }).setZone(
    timezone || "America/New_York"
  );
}

/**
 *
 * @param {*} obj - a viewcy api event object
 * @returns a date string eg Friday, Jan 19, 2024
 */
function formatDayMonthYear(obj) {
  if (!obj.events.length) return null;
  const timezone = obj.timezone || "America/New_York";
  const dt = toVenueTime(obj.events[0].starts_at, timezone);

  // Format: "Wednesday, Nov 26, 2025"
  return dt.toFormat("cccc, LLL d, yyyy");
}

/**
 *
 * @param {*} obj a viewcy api event object
 * @returns an html paragraph to display event date and time
 */
export function formatDate(obj) {
  if (!obj.events.length) return null;
  const timezone = obj.timezone || "America/New_York";
  const dt = toVenueTime(obj.events[0].starts_at, timezone);

  // Format: "8:00PM EST"
  const timeString = dt.toFormat("h:mma ZZZZ");

  return (
    <p className="date">
      <span>
        <FaRegCalendarAlt fontSize={"20px"} />
        {formatDayMonthYear(obj)}
      </span>
      <span>
        <FaRegClock fontSize={"20px"} />
        {timeString}
      </span>
    </p>
  );
}

export function formatParagraph(paragraph) {
  // The base length accounts for the "Read More" text and any necessary spaces and HTML characters
  const baseLength = "... ".length;
  const maxChars = window.innerWidth < 1024 ? 120 : 140;
  // Start with a full paragraph, then reduce word by word until it fits
  let words = paragraph.split(" ");
  let truncatedParagraph = paragraph;
  while (truncatedParagraph.length + baseLength > maxChars) {
    words.pop();
    truncatedParagraph = words.join(" ");
  }

  return `${truncatedParagraph}... `;
}

// Both must agree with the month keys and day buttons built in
// calendarFunctions, so they share the same clamped occurrence start.
export function getEventMonth(obj) {
  return monthKey(occurrenceStart(obj));
}

export function getEventDate(obj) {
  return occurrenceStart(obj).day;
}
